/** 投稿先（媒体）の表示名。サーバーの services/variantText.ts の platformLabel と揃える */
export type Platform = 'x' | 'threads' | 'instagram' | 'wordpress'

const LABEL: Record<Platform, string> = { x: 'X', threads: 'Threads', instagram: 'Instagram', wordpress: 'WordPress' }

export function platformLabel(platform: string): string {
  return LABEL[platform as Platform] ?? platform
}

/** 長期トークンを貼って接続する媒体（認証切れのとき、同じチャンネルにトークンを入れ直せる） */
export function usesPastedToken(platform: string): platform is 'threads' | 'instagram' {
  return platform === 'threads' || platform === 'instagram'
}

/** 「下書きとして自動投入」を選べるのは下書きのある媒体だけ */
export function supportsAutoDraft(platform: string): boolean {
  return platform === 'wordpress'
}
